import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import PostApiCall from "../../Api";

export default function QrCodeTextGenerator() {
  const [jobId, setJobId] = useState(null);
  const [jobType, setJobType] = useState('Text Job');
  const [jobName, setJobName] = useState("");
  const [texts, setTexts] = useState([]);
  const [sheetWidth, setSheetWidth] = useState(350); // mm
  const [sheetHeight, setSheetHeight] = useState(200); // mm
  const [verticalSpacing, setVerticalSpacing] = useState(30); // mm
  const [horizontalSpacing, setHorizontalSpacing] = useState(40); // mm
  const [topSpacing, setTopSpacing] = useState(20); // mm
  const [leftSpacing, setLeftSpacing] = useState(10); // mm
  const [fromPage, setFromPage] = useState(1);
  const [toPage, setToPage] = useState(1);
  const [fontSize, setFontSize] = useState(5); // mm
  const [orientation, setOrientation] = useState("horizontal"); // or 'vertical'
  const [textRotation,seTextRotation] = useState(0);

  // 
  useEffect(() => {
    const localData = localStorage.getItem('JobTextDeimensions') ? JSON.parse(localStorage.getItem('JobTextDeimensions')) : null;
    if (localData) {
      setJobId(localData?.fld_id);
      setJobName(localData?.fld_job_name);
      setSheetHeight(localData?.fld_sheet_height);
      setSheetWidth(localData?.fld_sheet_width);
      setFontSize(localData?.fld_font_size);
      setTopSpacing(localData?.fld_top_spacing);
      setLeftSpacing(localData?.fld_left_spacing);
      setVerticalSpacing(localData?.fld_v_spacing);
      setHorizontalSpacing(localData?.fld_h_spacing);
      setOrientation(localData?.fld_orientation)
      setFromPage(localData?.fld_from_page);
      setToPage(localData?.fld_to_page);
      setJobType(localData?.fld_job_type);
    }
  }, [])

  const mmToPx = (mm) => (mm * 72) / 25.4; // convert mm to points (72 DPI)

  const sheetWidthPx = mmToPx(sheetWidth);
  const sheetHeightPx = mmToPx(sheetHeight);
  const topSpacingPx = mmToPx(topSpacing);
  const leftSpacingPx = mmToPx(leftSpacing);
  const verticalSpacingPx = mmToPx(verticalSpacing);
  const horizontalSpacingPx = mmToPx(horizontalSpacing);
  const fontSizePx = mmToPx(fontSize);

  // --- calculate rows and columns ---
  let cols = 0;
  {
    let curX = leftSpacingPx;
    while (curX <= sheetWidthPx) {
      cols++;
      curX += horizontalSpacingPx;
      if (cols > 1000) break;
    }
  }

  let rows = 0;
  {
    let curY = topSpacingPx;
    while (curY <= sheetHeightPx) {
      rows++;
      curY += verticalSpacingPx;
      if (rows > 1000) break;
    }
  }

  if (cols < 1) cols = 1;
  if (rows < 1) rows = 1;
  const perPage = cols * rows;
  const previewTexts = texts.slice(0, perPage);

  // --- upload Excel ---
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      const textList = json.filter((row) => row[0]).map((row) => row[0].toString());
      setTexts(textList);
    };
    reader.readAsArrayBuffer(file);
  };

  // --- generate PDF ---
  const generatePDF = async () => {
    try {

      var login = localStorage.getItem("LoginDetail");
      var details = JSON.parse(login);
      const response = await PostApiCall.postRequest(
        {
          jobId: jobId,
          jobType: jobType,
          jobName,
          texts,
          sheetWidth,
          sheetHeight,
          topSpacing,
          leftSpacing,
          rightSpacing: horizontalSpacing,
          bottomSpacing: verticalSpacing,
          fromPage,
          toPage,
          fontSize,
          orientation,
          updatedBy: details[0].fld_userid,
          createdBy: details[0].fld_userid,
          textRotation
        },
        "GenerateQrTextPdf"
      );

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${jobName || "TextLayout"}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error generating PDF:", err);
    }
  };

  // --- render ---
  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col xl="12">
            <Card>
              <div
                className="Bechofy-bg-soft-pink d-flex align-items-center"
                style={{ height: 60 }}
              >
                <h4 className="text-white ml-5 pb-0 mb-0">Text Label Layout Generator</h4>
              </div>
              <CardBody className="pt-0">
                <Row>
                  <Col lg={12} className="mt-4">
                    <Row>
                      <Col lg={6} className="mb-2">
                        <label className="my-1">Job Name:</label>
                        <input
                          className="form-control"
                          value={jobName}
                          onChange={(e) => setJobName(e.target.value)}
                        />
                      </Col>

                      <Col lg={6} className="mb-2">
                        <label className="my-1">Upload Excel:</label>
                        <input
                          className="form-control"
                          type="file"
                          style={{ display: "block" }}
                          accept=".xlsx, .xls"
                          onChange={handleFileUpload}
                        />
                      </Col>

                      <Col lg={3} className="mb-2">
                        <label className="my-1">Sheet Width (mm):</label>
                        <input
                          className="form-control"
                          type="number"
                          value={sheetWidth}
                          onChange={(e) => setSheetWidth(+e.target.value)}
                        />
                      </Col>
                      <Col lg={3} className="mb-2">
                        <label className="my-1">Sheet Height (mm):</label>
                        <input
                          className="form-control"
                          type="number"
                          value={sheetHeight}
                          onChange={(e) => setSheetHeight(+e.target.value)}
                        />
                      </Col>

                      <Col lg={3} className="mb-2">
                        <label className="my-1">V Spacing (mm):</label>
                        <input
                          className="form-control"
                          type="number"
                          value={verticalSpacing}
                          onChange={(e) => setVerticalSpacing(+e.target.value)}
                        />
                      </Col>

                      <Col lg={3} className="mb-2">
                        <label className="my-1">H Spacing (mm):</label>
                        <input
                          className="form-control"
                          type="number"
                          value={horizontalSpacing}
                          onChange={(e) => setHorizontalSpacing(+e.target.value)}
                        />
                      </Col>

                      <Col lg={3} className="mb-2">
                        <label className="my-1">Top Spacing (mm):</label>
                        <input
                          className="form-control"
                          type="number"
                          value={topSpacing}
                          onChange={(e) => setTopSpacing(+e.target.value)}
                        />
                      </Col>

                      <Col lg={3} className="mb-2">
                        <label className="my-1">Left Spacing (mm):</label>
                        <input
                          className="form-control"
                          type="number"
                          value={leftSpacing}
                          onChange={(e) => setLeftSpacing(+e.target.value)}
                        />
                      </Col>

                      <Col lg={3} className="mb-2">
                        <label className="my-1">Font Size (mm):</label>
                        <input
                          className="form-control"
                          type="number"
                          value={fontSize}
                          onChange={(e) => setFontSize(+e.target.value)}
                        />
                      </Col>
                      <Col lg={3} className="mb-2">
                                              <label className="my-1">Rotation of Text (deg):</label>
                                              <input className="form-control" type="number" value={textRotation} onChange={(e) => seTextRotation(+e.target.value)} />
                                            </Col>

                      <Col lg={3} className="mb-2">
                        <label className="my-1">Orientation:</label>
                        <select
                          className="form-control"
                          value={orientation}
                          onChange={(e) => setOrientation(e.target.value)}
                        >
                          <option value="horizontal">Horizontal</option>
                          <option value="vertical">Vertical</option>
                        </select>
                      </Col>
                      <Col lg={3} className="mb-2">
                        <label className="my-1">From Page:</label>
                        <input className="form-control" type="number" value={fromPage} onChange={(e) => setFromPage(+e.target.value)} />
                      </Col>
                      <Col lg={3} className="mb-2">
                        <label className="my-1">To Page:</label>
                        <input className="form-control" type="number" value={toPage} onChange={(e) => setToPage(+e.target.value)} />
                      </Col>
                    </Row>
                  </Col>

                  {/* Preview */}
                  <Col lg={12}>
                    <h2 className="text-center mt-3">Preview</h2>

                    <div style={{ overflowX: "auto" }}>
                      <div
                        style={{
                          position: "relative",
                          width: `${sheetWidthPx}px`,
                          height: `${sheetHeightPx}px`,
                          border: "1px solid #000",
                          margin: "20px 0",
                          background: "white",
                        }}
                      >
                        {previewTexts.map((text, i) => {
                          const col = i % cols;
                          const row = Math.floor(i / cols);

                          // Base grid coordinates
                          const baseX = leftSpacingPx + col * horizontalSpacingPx;
                          const baseY = topSpacingPx + row * verticalSpacingPx;

                          // Adjust position for vertical orientation
                          const isVertical = orientation === "vertical";
                          const x = isVertical ? baseX + fontSizePx : baseX; // shift right slightly
                          const y = baseY;
                          const rotation =
                          orientation === "vertical"
                            ? 90 + Number(textRotation || 0)
                            : Number(textRotation || 0);
                        
                          return (
                            <div
                              key={i}
                              style={{
                                position: "absolute",
                                left: `${baseX}px`,
                                top: `${baseY}px`,
                                fontSize: `${fontSizePx}px`,
                                fontFamily: "Arial, sans-serif",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                                color: "#000",
                                transform: `rotate(${rotation}deg)`,
                                transformOrigin: "left center"
                              }}
                            >
                              {text}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="sticky-bottom p-2 bg-white">
                  <button
                    onClick={generatePDF}
                    className="btn Bechofy-btn btn-sm float-right"
                  >
                    Generate PDF
                  </button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
